// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eFob","title":"styles_title__1jIMU"};